import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import { IconButton, Tooltip, Stack, Icon } from "investira.react.components";
import { formats, dates, validators } from "investira.sdk";
import { BulkContextActions, DataTable } from "../../../components/organisms";
//import withEnquadramentos from "../../../hoc/withEnquadramentos";
const EnquadramentoSettings = memo((props) => {
  const {
    enquadramentos,
    state,
    columns,
    renderDetailPanel,
    onBulkDeleteClick,
    ...restProps
  } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const xColumns = useMemo(() => {
    return [
      {
        id: "enquadramento",
        accessorKey: "enquadramento",
        header: "Enquadramento",
        enableColumnActions: false,
        enableSorting: false,
        //size: 10000,
        muiTableHeadCellProps: {
          sx: {
            width: "100% !important",
          },
        },
        Cell: ({ cell }) => {
          console.log("enquadramento", cell.getValue());
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return cell.getValue();
        },
      },
      {
        id: "vigencia_inicio",
        accessorKey: "vigencia_inicio",
        header: "Vigência Início",
        enableColumnActions: false,
        enableSorting: false,
        //size: 10000,
        muiTableHeadCellProps: {
          sx: {
            width: "100% !important",
          },
        },
        Cell: ({ cell }) => {
          console.log("vi", cell.getValue());
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
      {
        id: "vigencia_fim",
        accessorKey: "vigencia_fim",
        header: "Vigência Fim",
        enableColumnActions: false,
        enableSorting: false,
        //size: 10000,
        muiTableHeadCellProps: {
          sx: {
            width: "100% !important",
          },
        },
        Cell: ({ cell }) => {
          console.log("vf", cell.getValue());
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
    ];
  }, []);

  const xProps = {
    columns: xColumns,
    data: props.enquadramentos,
    readData: props.readEntidadeEnquadramentos,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      columnVisibility: { carteira: false },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        "mrt-row-select": 50, // Largura fixa para a coluna de seleção
        "mrt-row-actions": 80, // Largura fixa para a coluna de ações
      },
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: (row) => row.log_id,
    state: {
      isLoading: props.isLoading,
      pagination: props.pagination,
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters,
      sorting: props.sorting,
      rowSelection: props.rowSelection,
    },
    rowCount: props.rowCount,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: true,
    renderTopToolbarCustomActions: ({ table }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            props.bulkDeleteEnquadramentos(selectedRows);
          }}
          disabled={props.isLoading || props.isRefetching || !isSomeRowSelected}
        />
      );
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: "100%", // Garante que a tabela ocupe 100% do espaço disponível
      },
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        size: 80, // largura em pixels para a coluna de ações
      },
      "mrt-row-select": {
        size: 50, // largura em pixels para a coluna de seleção
      },
    },
    renderRowActions: ({ row }) => {
      return (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Visualizar">
            <span>
              <IconButton
                color="primary"
                onClick={() =>
                  navigate(
                    `${location.pathname}/${row.original.enquadramento_id}`,
                    { state: row.original }
                  )
                }
              >
                <Icon iconName="eye" size={18} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Editar">
            <span>
              <IconButton
                color="primary"
                onClick={() =>
                  navigate(`${location.pathname}/edit`, { state: row.original })
                }
              >
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      );
    },
    ...restProps,
  };

  return <DataTable {...xProps} />;
});

export default EnquadramentoSettings;
//export default withEnquadramentos(EnquadramentoSettings);
